module.exports = __webpack_public_path__ + "static/media/imac_pro.e53d7bd2.svg";